export default {
	buttons: {
		auth: {
			login: "S'identifier",
			create_account: "Créer un compte",
		},
		general: {
			save: "sauvegarder",
			add: "Ajouter",
			edit: "Modifier",
			delete: "Effacer",
			grid: "Grille",
			list: "Liste",
			devices: "Dispositifs",
			patients: "Patients",
			manage: "Gérer",
			history: "Histoire",
			by_date: "Par date",
			actives: "Actifs",
			all: "Tout",
			upcoming: "Prochain",
			calendar: "Calendrier",
			by_day: "De jour",
			detach: "Détacher",
			attach: "Attacher",
			submit: "Soumettre",
			resume: "Résumé",
			response: "Réponse",
			configs: "Configurations",
			send: "Envoyer",
			report: "Rapport",
			attachment: "Attachment",
			see_all: "Voir tout"
		},
		actions: {
			get_more: "Avoir plus",
			add_group: "Ajouter un groupe",
			add_device: "Ajouter un appareil",
			add_patient: "Ajouter un patient",
			edit_group: "Editer le groupe",
			edit_device: "Editer l'appareil",
			edit_patient: "Editer le patient",
			view_all: "Voir tout",
			view_watch: "Voir la montre",
			clear_alerts: "Effacer les alertes",
			// user profile
			update_name: "Nom de mise à jour",
			update_email: "Mettre à jour l'email",
			update_password: "Mettre à jour le mot de passe",
			update_picture: "Mettre à jour la photo",
			// watch profile
			edit_profile: "Editer le profil",
			add_contact: "Ajouter le contact",
			edit_contact: "Editer le contact",
			add_disease: "Ajouter une maladie",
			edit_disease: "Editer une maladie",
			add_relation: "Ajouter une relation",
			add_relation_contact: "Ajouter un contact relationnel",
			edit_relation: "Editer une relation",
			edit_relation_contact: "Editer un contact relationnel",
			add_number: "Ajouter un numéro",
			edit_number: "Editer un numéro",
			add_insurance: "Ajouter une assurance",
			edit_insurance: "Editer une assurance",
			// pillbox
			add_pill: "Ajouter une pilule",
			// appointments
			add_appointment: "Ajouter un rendez-vous",
			// health reports
			add_healthreport: "Ajouter un rapport",
			edit_healthreport: "Editer le rapport",
			delete_healthreport: "Supprimer le rapport",
			// medical documents
			add_medicaldocument: "Ajouter un document",
			edit_medicaldocument: "Editer le document",
			view_report: "Voir le rapport",
			// readings
			add_parameters: "Ajouter des paramètres",
			edit_parameters: "Editer les paramètres",
			delete_parameters: "Supprimer les paramètres",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/buttons/buttons_fr.js